import React, { Component } from "react";
import Logger from "../../models/Logger";
import settings from "../../settings";
import FetchResponses from "../../models/FetchResponses";
import { Redirect } from "react-router-dom";
import Error from "./Error";
import { Messages, translateDetails } from "../../models/Messages";
import "antd/dist/antd.css";
import { Modal } from "antd";
import { isMobile } from "react-device-detect";
import InputChagePassword from "./InputChagePassword";
import BarLoader from "react-spinners/BarLoader";
// import InputMask from "react-input-mask";

class CodigoRegistro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: "",
      password_1: "",
      password_2: "",
      password_1_valid: false,
      password_2_valid: false,
      password_1_success: '',
      password_1_error: "",
      password_2_error: "",
      redirect_login: false,
      error_message: "",
      open: false,
      is_valid_code: false,
    };
    Logger.setLogger(this.constructor.name);
  }

  handleChange = (event) => {
    const newPassword = event.target.value;
    const id = event.target.id;
    let passwordValid = false;
    let error = '';
    let success = "";

    const newState = {
      [id]: newPassword
    };
  
    if (id === 'password_2') {
      if (this.state.password_1 === newPassword) {
        passwordValid = true;
      } else {
        error = 'Las contraseñas no coinciden entre sí';
      }
  
      newState['password_2_valid'] = passwordValid;
      newState['password_2_error'] = error;
    } else {
      const errors = [];
  
      if (newPassword.length < 8) errors.push('al menos 8 caracteres');
      if (!/[A-Z]/.test(newPassword)) errors.push('una letra mayúscula');
      if (!/[a-z]/.test(newPassword)) errors.push('una letra minúscula');
      if (!/\d/.test(newPassword)) errors.push('un número');
      if (!/[~`!@#$%^&*()\-+={}[\]|\\:;"'<>,.?/_₹]/.test(newPassword)) {
        errors.push('un carácter especial (!@#$%^.,-_&*)');
      }
  
      if (errors.length === 0) {
        passwordValid = true;
        error = '';
        success = "La contraseña cumple con los requisitos de seguridad."
      } else {
        error = 'La contraseña debe contener ' + errors.join(', ');
      }

      if (this.state.password_2) {
        const confirmPassword = this.state.password_2;
        const passwordsMatch = newPassword === confirmPassword;
      
        newState['password_2'] = confirmPassword;
        newState['password_2_valid'] = passwordsMatch;
        newState['password_2_error'] = passwordsMatch ? '' : 'Las contraseñas no coinciden entre sí';
      }
  
      newState['password_1_valid'] = passwordValid;
      newState['password_1_error'] = error;
      newState['password_1_success'] = success;
    }
  
    // 👇 Usamos los valores locales actualizados para calcular el estado del botón
    const finalPassword1Valid = id === 'password_1' ? passwordValid : this.state.password_1_valid;
    const finalPassword2Valid = newState['password_2_valid']


  
    newState['is_valid_code'] = finalPassword1Valid && finalPassword2Valid;
  
    this.setState(newState);
  };

  successRegister = (response) => {
    this.setState({
      open: true,
      error_message: Messages.userRegisterSuccessfully,
    });
  };

  failureRegister = (error) => {
    Logger.error(error);
    this.setState({
      open: true,
      error_message: translateDetails(error.detail),
      token: "",
      password_1: "",
      password_2: "",
      is_valid_code: false,
    });
  };

  validate_data = () => {
    return this.state.token.length >= 6 && this.state.token.length <= 12;
  };

  validate_password = () => {
    return this.state.password_1 === this.state.password_2;
  };

  handleClose = () => {
    if (this.state.error_message === Messages.userRegisterSuccessfully) {
      window.location.replace("/login");
    }
    this.setState({ open: false });
  };

  registerUser = (event) => {
    event.preventDefault();
    if (this.validate_password() && this.state.password_1.length >= 8) {
      const data = {
        token: "123456",
        password_1: this.state.password_1,
        password_2: this.state.password_2,
        fiscal_number: this.props.fiscal_number,
      };
      Logger.warn("I send this to register: " + JSON.stringify(data));
      fetch(settings.backend.register, {
        method: "POST",
        body: JSON.stringify(data),
        headers: settings.headers_super_auth,
      }).then(FetchResponses.processResponse)
        .then(this.successRegister)
        .catch(this.failureRegister);
    }

    if (!this.validate_password()) {
      this.setState({
        open: true,
        error_message: Messages.passwordsDoesNotMatch,
      });
    }

    if (this.state.password_1.length < 8) {
      this.setState({
        open: true,
        error_message: Messages.passwordLenght,
      });
    }
  };

  registerClose = (event) => {
    event.preventDefault();
    this.setState({
      token: "",
      password_1: "",
      password_2: "",
      is_valid_code: false,
    });
    this.props.registerClose();
  };

  validStyle = () => {
    if (isMobile) {
      return { top: 10 };
    }
  };

  preRegisterUser = (event) => {
    this.setState({
      token: "",
      password_1: "",
      password_2: "",
      is_valid_code: false,
    });
    this.props.preRegisterUser(event);
    event.preventDefault();
  };

  render() {
    if (this.state.redirect_login) {
      return <Redirect to={"/login"} />;
    }
    if (!this.props.openCodigoRegistro) {
      return null;
    }
    let style = this.validStyle();
    return (
      <div>
        <Modal
          visible={this.props.openCodigoRegistro}
          onCancel={this.registerClose}
          maskClosable={false}
          footer={null}
          style={style}
          title={"Digita el código que te enviamos a tu email/celular"}>
          <form onSubmit={this.registerUser}>
            <div className="form-group">
              <InputChagePassword
                className="form-control"
                id="password_1"
                placeholder="Ingresa una contraseña segura"
                title="Contraseña" 
                required
                requisitos
                successMessage={this.state.password_1_success}
                value={this.state.password_1}
                errorMessage={this.state.password_1_error}
                onChange={this.handleChange}
                minLength={8}
              />{" "}
            </div>{" "}
            <div className="form-group">
              <InputChagePassword
                className="form-control"
                id="password_2"
                placeholder="Ingresa nuevamente tu contraseña segura"
                required
                title="Confirmar Contraseña" 
                value={this.state.password_2}
                errorMessage={this.state.password_2_error}
                onChange={this.handleChange}
                minLength={8}
              />{" "}
            </div>

            <div className="row justify-content-center mt-3">
              <div className="col-12 col-sm-6">
                <div className="d-grid">
                  <button className="btn btn-primary btn-modal" 
                  type="submit" color="primary" 
                  disabled={!this.state.is_valid_code}>Aceptar</button>
                </div>
              </div>
            </div>

            {/* <div className="row justify-content-center">
              <div className="col-12 col-sm-6">
                <button
                  className="btn btn-primary btn-modal margin-codigos"
                  type="submit"
                  disabled={e}
                >
                  Aceptar{" "}
                </button>{" "}
              </div>{" "}
            </div> */}
            <div className="row justify-content-center">
              <BarLoader
                sizeUnit="%"
                height={5}
                width={500}
                color="#ff0000"
                loading={this.props.loading}
              />{" "}
            </div>
            <Error
              open={this.state.open}
              error_message={this.state.error_message}
              handleClose={this.handleClose}
            />{" "}
          </form>{" "}
        </Modal>{" "}
      </div>
    );
  }
}

export default CodigoRegistro;
